const development={
   identity:
   {
        client_id: "js",
        authority: 'https://identity.qa.umbai.africa',
        redirect_uri: 'https://qa.umbai.africa/callback',
        post_logout_redirect_uri: 'https://qa.umbai.africa/',
        silent_redirect_uri: 'https://qa.umbai.africa/static/silent-renew.html',
        register:'https://identity.qa.umbai.africa/account/register'
},
    isMobile:false,
    originator:'za',
    originatorCurrency:'R',
    gateway:"https://gateway.qa.umbai.africa/",
    credits:'https://gateway.qa.umbai.africa/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.qa.umbai.africa/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.qa.umbai.africa/credits/withdrawal',
    initiatePayment:'https://gateway.qa.umbai.africa/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.qa.umbai.africa/api/account/ForgotPassword',
    passwordreset:'https://identity.qa.umbai.africa/api/account/PasswordReset',
    airtimeProduct:'https://gateway.qa.umbai.africa/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.qa.umbai.africa/payment/AirTimeProducts/QueryZesaProduct'
    }

const production={
    identity:
    {
        client_id: "js",
        authority: 'https://identity.umbai.co.za',
        redirect_uri: 'https://umbai.co.za/callback',
        post_logout_redirect_uri: 'https://umbai.co.za/',
        silent_redirect_uri: 'https://umbai.co.za/static/silent-renew.html',
        register:'https://identity.umbai.co.za/account/register'
    },
    originator:'za',
    originatorCurrency:'R',
    isMobile:false,
    gateway:"https://gateway.umbai.co.za/",
    credits:'https://gateway.umbai.co.za/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.umbai.co.za/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.umbai.co.za/credits/withdrawal',
    initiatePayment:'https://gateway.umbai.co.za/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.umbai.co.za/api/account/ForgotPassword',
    passwordreset:'https://identity.umbai.co.za/api/account/PasswordReset',
    airtimeProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryZesaProduct'
 } 
 const africa={
    identity:
    {
        client_id: "js",
        authority: 'https://identity.umbai.co.za',
        redirect_uri: 'https://umbai.africa/callback',
        post_logout_redirect_uri: 'https://umbai.africa/',
        silent_redirect_uri: 'https://umbai.africa/static/silent-renew.html',
        register:'https://identity.umbai.co.za/account/register'
    },
    isMobile:false,
    originator:'mw',
    originatorCurrency:'MWK',
    gateway:"https://gateway.umbai.co.za/",
    credits:'https://gateway.umbai.co.za/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.umbai.co.za/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.umbai.co.za/credits/withdrawal',
    initiatePayment:'https://gateway.umbai.co.za/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.umbai.co.za/api/account/ForgotPassword',
    passwordreset:'https://identity.umbai.co.za/api/account/PasswordReset',
    airtimeProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryZesaProduct'
 } 
 const staging={
    identity:
    {
        client_id: "js",
        authority: 'https://identity.qa.umbai.africa',
        redirect_uri: 'https://qa.umbai.africa/callback',
        post_logout_redirect_uri: 'https://qa.umbai.africa/',
        silent_redirect_uri: 'https://qa.umbai.africa/static/silent-renew.html',
        register:'https://identity.qa.umbai.africa/account/register'
    },
    isMobile:false,
    originator:'za',
    originatorCurrency:'R',
    gateway:"https://gateway.qa.umbai.africa/",
    credits:'https://gateway.qa.umbai.africa/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.qa.umbai.africa/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.qa.umbai.africa/credits/withdrawal',
    initiatePayment:'https://gateway.qa.umbai.africa/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.qa.umbai.africa/api/account/ForgotPassword',
    passwordreset:'https://identity.qa.umbai.africa/api/account/PasswordReset',
    airtimeProduct:'https://gateway.qa.umbai.africa/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.qa.umbai.africa/payment/AirTimeProducts/QueryZesaProduct'
 }
 
 const mobile={
    identity:
    {
        client_id: "mobile",
        authority: 'https://identity.umbai.co.za',
        redirect_uri: 'com.umbai.app://umbai.co.za/callback',
        post_logout_redirect_uri: 'com.umbai.app://umbai.co.za/landing',
        silent_redirect_uri: 'com.umbai.app://umbai.co.za/static/silent-renew.html',
        register:'https://identity.umbai.co.za/account/register'
    },
    isMobile:true,
    originator:'za',
    originatorCurrency:'R',
    gateway:"https://gateway.umbai.co.za/",
    credits:'https://gateway.umbai.co.za/credits/ViewWalletBalance?',
    walletTransactions:'https://gateway.umbai.co.za/credits/ViewWalletTransactions?',
    walletWithdrawal:'https://gateway.umbai.co.za/credits/withdrawal',
    initiatePayment:'https://gateway.umbai.co.za/payment/Payment/InitiatePayment',
    forgotpassword:'https://identity.umbai.co.za/api/account/ForgotPassword',
    passwordreset:'https://identity.umbai.co.za/api/account/PasswordReset',
    airtimeProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryAirTimeProduct',
    zesaProduct:'https://gateway.umbai.co.za/payment/AirTimeProducts/QueryZesaProduct'
 }

let config=process.env.NODE_ENV === 'production'?production:development;

 config=process.env.VUE_APP_ENV==='staging'?staging:config;

 config=process.env.VUE_APP_ENV==='mobile'?mobile:config;

 config=process.env.VUE_APP_ENV==='africa'?africa:config;
 
 export  {config as default}